import _slicedToArray from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Delta from 'quill-delta';
import Parchment from 'parchment';
import Block from '../blots/block';
import Inline from '../blots/inline';
import TextBlot from '../blots/text';

var Code =
/*#__PURE__*/
function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, _getPrototypeOf(Code).apply(this, arguments));
  }

  return Code;
}(Inline);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock =
/*#__PURE__*/
function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodeBlock).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: "delta",
    value: function delta() {
      var _this = this;

      var text = this.domNode.textContent;

      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }

      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this.formats());
      }, new Delta());
    }
  }, {
    key: "format",
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _this$descendant = this.descendant(TextBlot, this.length() - 1),
          _this$descendant2 = _slicedToArray(_this$descendant, 1),
          text = _this$descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }

      _get(_getPrototypeOf(CodeBlock.prototype), "format", this).call(this, name, value);
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;

      if (Parchment.query(name, Parchment.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }

      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);

      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _this$descendant3 = this.descendant(TextBlot, index),
          _this$descendant4 = _slicedToArray(_this$descendant3, 2),
          text = _this$descendant4[0],
          offset = _this$descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: "length",
    value: function length() {
      var length = this.domNode.textContent.length;

      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }

      return length;
    }
  }, {
    key: "newlineIndex",
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(Parchment.create('text', '\n'));
      }

      _get(_getPrototypeOf(CodeBlock.prototype), "optimize", this).call(this, context);

      var next = this.next;

      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: "replace",
    value: function replace(target) {
      _get(_getPrototypeOf(CodeBlock.prototype), "replace", this).call(this, target);

      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = Parchment.find(node);

        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof Parchment.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: "create",
    value: function create(value) {
      var domNode = _get(_getPrototypeOf(CodeBlock), "create", this).call(this, value);

      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: "formats",
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(Block);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';
export { Code, CodeBlock as default };